import React from "react";
import { useSelector } from "react-redux";
import ReceiptMessage from "./ReceiptMessage";
import {
    selectRegistrationAccount,
    updateRegistrationAccountSubmittedMessage,
} from "../../../redux/slices/registrationAccountSlice";

const ConnectedReceiptMessage = () => {
    const registrationAccount = useSelector(selectRegistrationAccount);
    const {
        form: { submittedMessage },
    } = registrationAccount;

    return (
        <ReceiptMessage
            submittedMessage={submittedMessage}
            updateRegistrationAccountSubmittedMessage={
                updateRegistrationAccountSubmittedMessage
            }
        />
    );
};

export default ConnectedReceiptMessage;
